import { useState } from 'react';

import Tabs from '@cartwhl/ui/molecules/Tabs';

import { EXPORT_TYPES } from 'stores/animationGenerationStore';

import DownloadFile from './DownloadFile';
import DownloadVideo from './DownloadVideo';
import TabItem from './TabItem';

interface MotionDownloadProps {
  handleOpenChange: (open: boolean) => void;
}

export default function MotionDownload({
  handleOpenChange,
}: MotionDownloadProps) {
  const [downloadFormat, setDownloadFormat] = useState<EXPORT_TYPES>(
    EXPORT_TYPES.MP4,
  );

  return (
    <Tabs
      tabListClassName="-mx-4 lg:mx-0 px-4 lg:px-0"
      tabs={[
        {
          value: EXPORT_TYPES.MP4,
          label: <TabItem>Video</TabItem>,
          content: <DownloadVideo handleOpenChange={handleOpenChange} />,
        },
        {
          value: EXPORT_TYPES.BVH,
          label: <TabItem>BVH</TabItem>,
          content: (
            <DownloadFile
              tab={EXPORT_TYPES.BVH}
              downloadFormat={downloadFormat}
              setDownloadFormat={setDownloadFormat}
              handleOpenChange={handleOpenChange}
            />
          ),
        },
        {
          value: EXPORT_TYPES.FBX_MAYA,
          label: <TabItem>FBX</TabItem>,
          content: (
            <DownloadFile
              tab={EXPORT_TYPES.FBX_MAYA}
              downloadFormat={downloadFormat}
              setDownloadFormat={setDownloadFormat}
              handleOpenChange={handleOpenChange}
            />
          ),
        },
        {
          value: EXPORT_TYPES.GLB,
          label: <TabItem>glTF</TabItem>,
          content: (
            <DownloadFile
              tab={EXPORT_TYPES.GLB}
              downloadFormat={downloadFormat}
              setDownloadFormat={setDownloadFormat}
              handleOpenChange={handleOpenChange}
            />
          ),
        },
        {
          value: EXPORT_TYPES.MA,
          label: <TabItem isPro>Maya</TabItem>,
          content: (
            <DownloadFile
              tab={EXPORT_TYPES.MA}
              downloadFormat={downloadFormat}
              setDownloadFormat={setDownloadFormat}
              handleOpenChange={handleOpenChange}
            />
          ),
        },
      ]}
    />
  );
}
